export default "__VITE_PUBLIC_ASSET__b58a3c14__"